// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--d91d1";
export var active = "accordion-module--active--62d74";
export var icon = "accordion-module--icon--2d8b1";
export var panel = "accordion-module--panel--3e213";